import React from "react";
import Calender from "./Calender";
import User1 from "../../../assets/images/user1.png";
import User2 from "../../../assets/images/user2.png";
import User3 from "../../../assets/images/user3.png";
import User4 from "../../../assets/images/user4.png";
import Plus from "../../../assets/svgs/Plus";

function RightSideHeader() {
  return (
    <div className="mt-8 mb-5 xl:mt-0 flex flex-wrap justify-start lg:justify-between">
      <div className="flex flex-col w-fit mx-4 my-2">
        <p className="text-lg">1,357484838</p>
        <small>Salary</small>
      </div>
      <div className="flex flex-col w-fit mx-4 my-2">
        <p className="text-lg">1,357484</p>
        <small>Bonuses</small>
      </div>
      <div className="flex flex-col w-fit mx-4 my-2">
        <p className="text-lg">1,35838</p>
        <small>Bonuses</small>
      </div>
      <div className="flex flex-col w-fit mx-4 my-2">
        <p className="text-lg">1,35838</p>
        <small>Employer Cost</small>
      </div>
      <div className="flex flex-col w-fit mx-4 my-2">
        <p className="text-lg">1,35838</p>
        <small>Gross</small>
      </div>
    </div>
  );
}

function SightSideCard({ amount, subtitle, title, btnText }) {
  return (
    <div className="p-3 w-full bg-white shadow-lg rounded">
      <p className="text-xs">{subtitle}</p>
      <p className="text-lg my-1">{title}</p>
      <div className="flex justify-between items-center">
        <small>{amount && amount}</small>
        <button className="py-1 px-3 text-sm rounded-sm bg-pink-500 text-white shadow-md">
          {btnText}
        </button>
      </div>
    </div>
  );
}

const RightSide = () => {
  return (
    <div className="xl:max-w-screen-sm">
      <RightSideHeader />
      <div className="w-full xl:mt-0 p-2 flex flex-col lg:flex-row lg:justify-between lg:space-x-7">
        <div className="space-y-5 xl:w-96 py-5 lg:py-0 pr-1 max-h-screen overflow-y-auto">
          <SightSideCard
            amount="Total of €1,000"
            subtitle="Invoices due"
            title="1 Payment due and 2 overdue"
            btnText="play Now"
          />
          <SightSideCard
            subtitle="Timesheets for aproval"
            title="4 submissions to approve"
            btnText="Approve"
          />
          <SightSideCard
            subtitle="Timesheets for aproval"
            title="4 Payroll to approve"
            btnText="Approve"
          />
          <SightSideCard
            subtitle="Timesheets for aproval"
            title="4 Leave to approve"
            btnText="Approve"
          />
        </div>

        {/* Calender */}
        <div className="">
          <Calender />
          <br />

          {/* Active or Inactive User UI */}
          <div className="shadow-lg w-full lg:w-96 p-5 bg-white rounded">
            <p>Active 09</p>
            <div className="flex space-x-2">
              <img
                src={User1}
                className="w-8 h-8 rounded-full cursor-poitner"
                alt=""
              />
              <img
                src={User2}
                className="w-8 h-8 rounded-full cursor-poitner"
                alt=""
              />
              <img
                src={User3}
                className="w-8 h-8 rounded-full cursor-poitner"
                alt=""
              />
              <img
                src={User4}
                className="w-8 h-8 rounded-full cursor-poitner"
                alt=""
              />
              <button className="w-8 h-8 rounded-full bg-pink-600 text-white flex items-center justify-center">
                <Plus />
              </button>
            </div>
          </div>
          <br />
          <div className="shadow-lg w-full lg:w-96 p-5 bg-white rounded">
            <p>Inactive 09</p>
            <div className="flex space-x-2">
              <img
                src={User1}
                className="w-8 h-8 rounded-full cursor-poitner"
                alt=""
              />
              <img
                src={User2}
                className="w-8 h-8 rounded-full cursor-poitner"
                alt=""
              />
              <img
                src={User3}
                className="w-8 h-8 rounded-full cursor-poitner"
                alt=""
              />
              <img
                src={User4}
                className="w-8 h-8 rounded-full cursor-poitner"
                alt=""
              />
              <button className="w-8 h-8 rounded-full bg-pink-600 text-white flex items-center justify-center">
                <Plus />
              </button>
            </div>
          </div>
          {/* Active or Inactive User UI */}
        </div>
      </div>
    </div>
  );
};

export default RightSide;
